import {
    getCurrentMemberSubscription,
    getFutureMemberSubscription,
    getMemberSubscriptionPaymentCard,
} from '@vista-digital/occ-domain'
import { useOccContext } from '@vista-digital/occ-ui'
import { getMemberSubscriptionNotificationType } from '@vista-digital/occ-ui/src/lib/components/member/subscription-notification/utils/get-member-subscription-notification-type'
import { useMemo } from 'react'

/*
 * Returns the number of subscription notifications supported by the current implementation.
 */
export const useSubscriptionNotifications = () => {
    const {
        config: { member: memberConfig },
    } = useOccContext()

    const currentSubscription = getCurrentMemberSubscription()
    const futureSubscription = getFutureMemberSubscription()
    const subscriptionPaymentCard = getMemberSubscriptionPaymentCard()

    return useMemo(() => {
        let notificationsCount = 0

        const hasNotifications =
            !!currentSubscription &&
            !!getMemberSubscriptionNotificationType(
                memberConfig,
                currentSubscription,
                futureSubscription,
                subscriptionPaymentCard
            )
        // The MemberSubscriptionNotification component from the library only supports rendering a single subscription notification at a time
        if (hasNotifications) notificationsCount += 1

        return {
            notificationsCount,
            hasNotifications: notificationsCount > 0,
        }
    }, [memberConfig, currentSubscription, futureSubscription, subscriptionPaymentCard])
}
